<template>
  <div id="app">
    <div class="router-view-container">
      <router-view :key="$route.fullPath" v-if="isShow" />
      <!-- <router-view :key="$route.fullPath"/> -->
    </div>
    <loading ref="loading"></loading>
    <transition ref="transition"></transition>
  </div>
</template>

<script>
import loading from "./components/loadingPage";
import transition from "./components/transitionPage";
export default {
  name: "App",
  components: {
    loading,
    transition,
  },
  mounted() {
    this.$refs.loading.show();
    setTimeout(() => {
      this.$refs.loading.hide();
      this.$refs.transition.show();
      setTimeout(() => {
        this.$refs.transition.hide();
        this.isShow = true;
      }, 3000);
    }, 2000);
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {},
};
</script>

<style lang="scss">
#app {
  .router-view-container {
    position: relative;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue